import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ScanOrBoxSubmitRes } from '../../types/Scan';
import { completeScanOrBox } from '../Scans';
import { getBoxQueryKey } from './useGetBox';
import { getScanQueryKey } from './useGetScan';

export const useValidateAndCompleteScanOrBox = (
    onSuccess?: (data: ScanOrBoxSubmitRes) => void,
    onError?: (error: AxiosError) => void
) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: completeScanOrBox,
        onSuccess: (_data, variables) => {
            const { boxId, scanId } = variables;

            if (boxId) {
                queryClient.invalidateQueries({ queryKey: getBoxQueryKey(boxId) });
            }

            if (scanId) {
                queryClient.invalidateQueries({ queryKey: getScanQueryKey(scanId) });
            }

            queryClient.invalidateQueries({ queryKey: ['scans'] });
            onSuccess?.(_data);
        },
        onError: (error: AxiosError) => onError?.(error)
    });
};
